import React from "react";
import { Button } from "../components/ui/button";
import { LoginCompanyPanel, MobileCompanyIdentity } from "../components/LoginCompanyBrand";

export default function Login() {
  // PHASE-B1: neutral message for uninvited Google accounts
  const denied = new URLSearchParams(window.location.search).get("denied") === "1";
  // MT-11B.7: visible generic error for unexpected sign-in failures
  const signInError = new URLSearchParams(window.location.search).get("error") === "1";
  const handleLogin = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/dashboard";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className={`login-page${denied || signInError ? " login-page-with-notice" : ""}`} data-testid="login-page">
      {denied && (
        <div role="alert" className="login-notice bg-amber-50 border-b border-amber-300 text-amber-900 text-sm text-center px-4 py-2" data-testid="login-denied-banner">
          Access not authorised — contact the clinic administrator.
        </div>
      )}
      {signInError && !denied && (
        <div role="alert" className="login-notice bg-rose-50 border-b border-rose-300 text-rose-900 text-sm text-center px-4 py-2" data-testid="login-error-banner">
          Sign-in didn't complete. Please try again — if it keeps happening, contact the clinic administrator.
        </div>
      )}
      <LoginCompanyPanel />

      {/* Right: sign in */}
      <div className="login-signin-panel flex items-center justify-center p-8" data-testid="login-signin-panel">
        <div className="w-full max-w-sm">
          <MobileCompanyIdentity />
          <div className="overline" data-testid="login-signin-label">SIGN IN</div>
          <h2 className="font-heading text-3xl font-semibold mt-2 text-slate-900" data-testid="login-welcome-title">Welcome back.</h2>
          <p className="mt-2 text-sm text-slate-600" data-testid="login-signin-description">
            Continue with your Google account. Your role — <strong>Doctor</strong>, <strong>Receptionist</strong> or <strong>Nurse</strong> — is set by the clinic admin, and you'll be routed to the right workspace automatically after sign-in.
          </p>
          <div className="mt-4 grid grid-cols-3 gap-2 text-[11px]" data-testid="login-role-summary">
            <div className="border border-pink-200 bg-pink-50 rounded-md p-2 text-pink-800" data-testid="login-role-doctor">
              <div className="font-semibold uppercase tracking-wider text-[9px]" data-testid="login-role-doctor-label">Doctor</div>
              <div className="mt-0.5 leading-tight" data-testid="login-role-doctor-access">Full clinical suite</div>
            </div>
            <div className="border border-sky-200 bg-sky-50 rounded-md p-2 text-sky-800" data-testid="login-role-reception">
              <div className="font-semibold uppercase tracking-wider text-[9px]" data-testid="login-role-reception-label">Reception</div>
              <div className="mt-0.5 leading-tight" data-testid="login-role-reception-access">Intake &amp; uploads only</div>
            </div>
            <div className="border border-emerald-200 bg-emerald-50 rounded-md p-2 text-emerald-800" data-testid="login-role-nurse">
              <div className="font-semibold uppercase tracking-wider text-[9px]" data-testid="login-role-nurse-label">Nurse</div>
              <div className="mt-0.5 leading-tight" data-testid="login-role-nurse-access">Vitals &amp; view</div>
            </div>
          </div>
          <Button
            onClick={handleLogin}
            data-testid="google-login-btn"
            className="w-full mt-8 h-11 bg-pink-600 hover:bg-pink-700 text-white rounded-md font-medium"
          >
            Continue with Google
          </Button>
          <p className="mt-6 text-xs text-slate-500 leading-relaxed" data-testid="login-clinical-disclaimer">
            By signing in, you agree that this tool provides clinical decision support and does not
            replace professional medical judgement.
          </p>
        </div>
      </div>
    </div>
  );
}
